export const ariaNamespace = 'Document_Media';

export const TranslationKeys = {
  ariaLabel: 'DocumentMedia_AriaLabel',
} as const;

export const TranslationFallbacks: Record<
  keyof typeof TranslationKeys,
  string
> = {
  ariaLabel: 'Document Button',
};
